
<div soho-busyindicator
  [style.height]="'100%'"
  [text]="' '"
  [blockUI]="true"
  [displayDelay]="20"
  [transparentOverlay]="true">

  @if (createReportShowMain && createReportForm) {
    <form [formGroup]="createReportForm" >
      <div class="row form-layout-compact">
        <div class="column">
          <div class="field">
            <label soho-label style="margin-bottom:20px">{{ 'HowWouldYouLikeToGetStarted' | translate }}</label>
          </div>
        </div>
      </div>
      <div class="row form-layout-compact">
        <div class="one-half column">
          <div class="field field-radio">
            <input soho-radiobutton soho-trackdirty type="radio" data-automation-id="lm-create-report-copy-from-report"
              id="reportTypeReport" value="ReportCopiedFromReport" (change)="changeReportType()" formControlName="reportType" />
              <label soho-label for="reportTypeReport" class="radio-label" data-automation-id="lm-create-report-copy-from-report-label">{{ 'CopyFromReport' | translate }}</label>
              <input soho-radiobutton soho-trackdirty type="radio" data-automation-id="lm-create-report-copy-from-list"
                id="reportTypeList" value="ReportCopiedFromList" (change)="changeReportType()" formControlName="reportType" />
                <label soho-label for="reportTypeList" class="radio-label" data-automation-id="lm-create-report-copy-from-list-label">{{ 'CopyFromList' | translate }}</label>
                <input soho-radiobutton soho-trackdirty type="radio" data-automation-id="lm-create-report-start-from-scratch"
                  id="reportTypeOwn" value="ReportFromScratch" (change)="changeReportType()" formControlName="reportType" />
                  <label soho-label for="reportTypeOwn" class="radio-label" data-automation-id="lm-create-report-start-from-scratch-label">{{ 'StartFromScratch' | translate }}</label>
                </div>
              </div>
            </div>
            <div class="row form-layout-compact ">
              <div class="column">
                <div class="field">
                  <label soho-label for="reportName" [required]="true">{{ 'CreateReportNameLabel' | translate }}</label>
                  <input class="input-lg" soho-input name="reportName"
                    id="reportName" data-automation-id="lm-create-report-report-name" soho-trackdirty
                    formControlName="reportName">
                    @if (((submitted || myForm.reportName.dirty) && myForm.reportName.errors)) {
                      <div id="name-error" class="error-message" data-automation-id="lm-create-report-report-name-alert">
                        <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                          <use href="#icon-error"></use>
                        </svg>
                        <pre class="audible">Error</pre>
                        @if (myForm.reportName.errors?.required) {
                          <p class="message-text">{{'NameIsRequiredErrorMessage' | translate}}</p>
                        }
                      </div>
                    }
                  </div>
                <!-- </div> -->
                <!-- <div [ngClass]="{'column': true, 'one-half': createReport.reportType !== 'ReportFromScratch'}"> -->
              <!-- </div>
              <div class="row form-layout-compact"> -->
                <!-- <div [ngClass]="{'one-half': createReport.reportType === 'ReportCopiedFromList' || createReport.reportType === 'ReportCopiedFromReport', 'column': true }"> -->
                <!-- <div class="column"> -->
                <div class="field">
                  <label soho-label [required]="true" for="businessClass">{{ 'CreateReportBusinessClassLabel' | translate }}</label>
                  <select #businessClass id="businessClass" name="businessClass" [attributes]="businessClassAutomationId"
                    soho-dropdown soho-trackdirty
                    formControlName="businessClass"
                    (change)="onBusClassChange()"
                    class="dropdown-lg">
                    @for (businessClass of businessClasses; track businessClass) {
                      <option [value]="businessClass.value">{{ businessClass.label }}</option>
                    }
                  </select>
                </div>
              <!-- </div> -->
            <!-- </div>
            <div class="row form-layout-compact">
              <div class="column"> -->
                @if (reportType.value === 'ReportCopiedFromList') {
                  <div class="field" >
                    <label soho-label [required]="true" for="listNameLookup">{{ 'CreateReportListLabel' | translate }}</label>
                    <input #listNameLookup soho-lookup
                      formControlName="listName"
                      name="listNameLookup" data-automation-id="lm-create-report-list-lookup"
                      soho-trackdirty
                      [click]="listLookupClick"
                      [clickArguments]="{'businessClass': busClass.value, 'reportType': reportType.value, 'createReportUrl': createReportUrl.value, 'component': this}"
                      class="dropdown-lg">
                      @if (((submitted || myForm.listName.dirty) && myForm.listName.errors)) {
                        <div id="listName-error" class="error-message" data-automation-id="lm-create-report-list-alert">
                          <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                            <use href="#icon-error"></use>
                          </svg>
                          <pre class="audible">Error</pre>
                          @if (myForm.listName.errors?.required) {
                            <p class="message-text">{{'ListIsRequiredErrorMessage' | translate}}</p>
                          }
                          @if (listName.value && myForm.listName.errors?.invalidListName) {
                            <p class="message-text">{{'ListNameDoesNotExist' | translate}}</p>
                          }
                        </div>
                      }
                    </div>
                  }
                <!-- </div>
                <div class="column"> -->
                  @if (reportType.value === 'ReportCopiedFromReport') {
                    <div class="field" >
                      <label soho-label [required]="true" for="userFolderLookup">{{ 'CreateReportLabel' | translate }}</label>
                      <input soho-lookup #userFolder formControlName="title"
                        name="userFolderLookup" data-automation-id="lm-create-report-userfolder-lookup"
                        soho-trackdirty
                        [click]="listLookupClick"
                        [clickArguments]="{'businessClass': busClass.value, 'reportType': reportType.value, 'createReportUrl': createReportUrl.value, 'component': this}"
                        class="dropdown-lg">
                        @if (((submitted || myForm.title.dirty) && myForm.title.errors)) {
                          <div id="title-error" class="error-message" data-automation-id="lm-create-report-report-alert">
                            <svg class="icon-error icon" focusable="false" aria-hidden="true" role="presentation">
                              <use href="#icon-error"></use>
                            </svg>
                            <pre class="audible">Error</pre>
                            @if (myForm.title.errors?.required) {
                              <p class="message-text">{{'ReportIsRequiredErrorMessage' | translate}}</p>
                            }
                            @if (title.value && myForm.title.errors?.invalidReportName) {
                              <p class="message-text">{{'ReportTitleDoesNotExist' | translate}}</p>
                            }
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
              </form>
            }

            @if (!createReportShowMain) {
              <ng-container #createReportFieldsSelector>
                <lm-create-report-fields-dialog
                  [businessClass]="busClass.value"
                  [listName]="listName.value"
                  [reportType]="reportType.value"
                  [userFolderId]="userFolderId.value"
                ></lm-create-report-fields-dialog>
              </ng-container>
            }
          </div>
